
import { defineComponent } from 'vue';
import { useStore } from 'vuex';

import NotesService from '@/modules/notes/services/scripts';
import BootstrapHelper from '@/utils/bootstrapHelpers';

export default defineComponent({
    emits: ['callback'],
    props: ['showStats', 'limit', 'allowMultiLine', 'notes'],
    data(props) {
        return {
            showCharacterStats: props.showStats || false,
            notesLimit: props.limit || 256,
            notesLimitErrorMessage: props.notesLimitMessage || `You have exceeded the character limit for notes.`,
            notesError: false,
            multiLines: props.allowMultiLine || false,
            notesCount: props.notes.length || 0,
            notesMessage: props.notes || ''
        };
    },
    setup() {
        const store = useStore();
        return { store };
    },
    mounted() {
        this.callback();
    },
    methods: {
        callback() {
            this.$emit('callback', {
                notes: this.notesMessage,
                hasError: this.notesError
            });
        },
        processNotes(e: any) {
            const notesDetails = NotesService.formatNotes({
                notesMultiLines: this.multiLines,
                notesLimit: this.notesLimit,
                notesValue: e.target.value
            });

            const notesContainer = e.target.closest('.notes-container');
            const count = notesContainer.getElementsByClassName('notes-count')[0];
            const countError = notesContainer.getElementsByClassName('notes-error')[0];

            if (notesDetails.notesError) {
                count.classList.add('text-red');
                countError.removeAttribute('hidden');
                BootstrapHelper.tooltipInitialize();
                this.notesError = notesDetails.notesError;
            } else {
                count.classList.remove('text-red');
                countError.setAttribute('hidden', 'true');
                this.notesError = notesDetails.notesError;
            }

            this.notesCount = notesDetails.notesValue.length;
            this.notesMessage = notesDetails.notesValue;

            this.callback();
        }
    }
});
